// extracted by mini-css-extract-plugin
export var formContainer = "_d1-0";
export var message = "_d1-1";